export default [
    { value: 'ab', label: 'Abkhaz' },
    { value: 'aa', label: 'Afar' },
    { value: 'af', label: 'Afrikaans' },
    { value: 'ak', label: 'Akan' },
    { value: 'sq', label: 'Albanian' },
    { value: 'am', label: 'Amharic' },
    { value: 'ar', label: 'Arabic' },
    { value: 'an', label: 'Aragonese' },
    { value: 'hy', label: 'Armenian' },
    { value: 'as', label: 'Assamese' },
    { value: 'av', label: 'Avaric' },
    { value: 'ae', label: 'Avestan' },
    { value: 'ay', label: 'Aymara' },
    { value: 'az', label: 'Azerbaijani' },
    { value: 'bm', label: 'Bambara' },
    { value: 'ba', label: 'Bashkir' },
    { value: 'eu', label: 'Basque' },
    { value: 'be', label: 'Belarusian' },
    { value: 'bn', label: 'Bengali' },
    { value: 'bh', label: 'Bihari' },
    { value: 'bi', label: 'Bislama' },
    { value: 'bs', label: 'Bosnian' },
    { value: 'br', label: 'Breton' },
    { value: 'bg', label: 'Bulgarian' },
    { value: 'my', label: 'Burmese' },
    { value: 'ca', label: 'Catalan' },
    { value: 'ch', label: 'Chamorro' },
    { value: 'ce', label: 'Chechen' },
    { value: 'ny', label: 'Chichewa' },
    { value: 'zh', label: 'Chinese' },
    { value: 'zh-cn', label: 'Chinese (Simplified/PRC)' },
    { value: 'zh-tw', label: 'Chinese (Traditional/Taiwan)' },
    { value: 'cv', label: 'Chuvash' },
    { value: 'kw', label: 'Cornish' },
    { value: 'co', label: 'Corsican' },
    { value: 'cr', label: 'Cree' },
    { value: 'hr', label: 'Croatian' },
    { value: 'cs', label: 'Czech' },
    { value: 'da', label: 'Danish' },
    { value: 'dv', label: 'Divehi' },
    { value: 'nl', label: 'Dutch' },
    { value: 'en', label: 'English' },
    { value: 'qme', label: 'Emoji' },
    { value: 'eo', label: 'Esperanto' },
    { value: 'et', label: 'Estonian' },
    { value: 'ee', label: 'Ewe' },
    { value: 'fo', label: 'Faroese' },
    { value: 'fj', label: 'Fijian' },
    { value: 'fi', label: 'Finnish' },
    { value: 'fr', label: 'French' },
    { value: 'ff', label: 'Fula' },
    { value: 'gl', label: 'Galician' },
    { value: 'ka', label: 'Georgian' },
    { value: 'de', label: 'German' },
    { value: 'el', label: 'Greek' },
    { value: 'gn', label: 'Guaraní' },
    { value: 'gu', label: 'Gujarati' },
    { value: 'ht', label: 'Haitian' },
    { value: 'ha', label: 'Hausa' },
    { value: 'he', label: 'Hebrew' },
    { value: 'hz', label: 'Herero' },
    { value: 'hi', label: 'Hindi' },
    { value: 'ho', label: 'Hiri Motu' },
    { value: 'hu', label: 'Hungarian' },
    { value: 'is', label: 'Icelandic' },
    { value: 'io', label: 'Ido' },
    { value: 'ig', label: 'Igbo' },
    { value: 'id', label: 'Indonesian' },
    { value: 'ia', label: 'Interlingua' },
    { value: 'ie', label: 'Interlingue' },
    { value: 'iu', label: 'Inuktitut' },
    { value: 'ik', label: 'Inupiaq' },
    { value: 'ga', label: 'Irish' },
    { value: 'it', label: 'Italian' },
    { value: 'ja', label: 'Japanese' },
    { value: 'jv', label: 'Javanese' },
    { value: 'kl', label: 'Kalaallisut' },
    { value: 'kn', label: 'Kannada' },
    { value: 'kr', label: 'Kanuri' },
    { value: 'ks', label: 'Kashmiri' },
    { value: 'kk', label: 'Kazakh' },
    { value: 'km', label: 'Khmer' },
    { value: 'ki', label: 'Kikuyu' },
    { value: 'rw', label: 'Kinyarwanda' },
    { value: 'rn', label: 'Kirundi' },
    { value: 'kv', label: 'Komi' },
    { value: 'kg', label: 'Kongo' },
    { value: 'ko', label: 'Korean' },
    { value: 'ku', label: 'Kurdish' },
    { value: 'kj', label: 'Kwanyama' },
    { value: 'ky', label: 'Kyrgyz' },
    { value: 'lo', label: 'Lao' },
    { value: 'la', label: 'Latin' },
    { value: 'lv', label: 'Latvian' },
    { value: 'li', label: 'Limburgish' },
    { value: 'ln', label: 'Lingala' },
    { value: 'lt', label: 'Lithuanian' },
    { value: 'lu', label: 'Luba-Katanga' },
    { value: 'lg', label: 'Luganda' },
    { value: 'lb', label: 'Luxembourgish' },
    { value: 'mk', label: 'Macedonian' },
    { value: 'mg', label: 'Malagasy' },
    { value: 'ms', label: 'Malay' },
    { value: 'ml', label: 'Malayalam' },
    { value: 'mt', label: 'Maltese' },
    { value: 'gv', label: 'Manx' },
    { value: 'mr', label: 'Marathi' },
    { value: 'mh', label: 'Marshallese' },
    { value: 'mn', label: 'Mongolian' },
    { value: 'mi', label: 'Māori' },
    { value: 'na', label: 'Nauru' },
    { value: 'nv', label: 'Navajo' },
    { value: 'ng', label: 'Ndonga' },
    { value: 'ne', label: 'Nepali' },
    { value: 'nd', label: 'North Ndebele' },
    { value: 'se', label: 'Northern Sami' },
    { value: 'no', label: 'Norwegian' },
    { value: 'nb', label: 'Norwegian Bokmål' },
    { value: 'nn', label: 'Norwegian Nynorsk' },
    { value: 'ii', label: 'Nuosu' },
    { value: 'oc', label: 'Occitan' },
    { value: 'oj', label: 'Ojibwe' },
    { value: 'cu', label: 'Old Church Slavonic' },
    { value: 'or', label: 'Oriya' },
    { value: 'om', label: 'Oromo' },
    { value: 'os', label: 'Ossetian' },
    { value: 'pa', label: 'Panjabi' },
    { value: 'ps', label: 'Pashto' },
    { value: 'fa', label: 'Persian' },
    { value: 'pl', label: 'Polish' },
    { value: 'pt', label: 'Portuguese (Portugal)' },
    { value: 'pt-br', label: 'Portuguese (Brazil)' },
    { value: 'pi', label: 'Pāli' },
    { value: 'qu', label: 'Quechua' },
    { value: 'ro', label: 'Romanian' },
    { value: 'rm', label: 'Romansh' },
    { value: 'ru', label: 'Russian' },
    { value: 'sm', label: 'Samoan' },
    { value: 'sg', label: 'Sango' },
    { value: 'sa', label: 'Sanskrit' },
    { value: 'sc', label: 'Sardinian' },
    { value: 'gd', label: 'Scottish' },
    { value: 'sr', label: 'Serbian' },
    { value: 'sn', label: 'Shona' },
    { value: 'sd', label: 'Sindhi' },
    { value: 'si', label: 'Sinhala' },
    { value: 'sk', label: 'Slovak' },
    { value: 'sl', label: 'Slovene' },
    { value: 'so', label: 'Somali' },
    { value: 'nr', label: 'South Ndebele' },
    { value: 'st', label: 'Southern Sotho' },
    { value: 'es', label: 'Spanish (Spain/LATAM)' },
    { value: 'su', label: 'Sundanese' },
    { value: 'sw', label: 'Swahili' },
    { value: 'ss', label: 'Swati' },
    { value: 'sv', label: 'Swedish' },
    { value: 'tl', label: 'Tagalog' },
    { value: 'ty', label: 'Tahitian' },
    { value: 'tg', label: 'Tajik' },
    { value: 'ta', label: 'Tamil' },
    { value: 'tt', label: 'Tatar' },
    { value: 'te', label: 'Telugu' },
    { value: 'th', label: 'Thai' },
    { value: 'bo', label: 'Tibetan' },
    { value: 'ti', label: 'Tigrinya' },
    { value: 'to', label: 'Tonga' },
    { value: 'ts', label: 'Tsonga' },
    { value: 'tn', label: 'Tswana' },
    { value: 'tr', label: 'Turkish' },
    { value: 'tk', label: 'Turkmen' },
    { value: 'tw', label: 'Twi' },
    { value: 'uk', label: 'Ukrainian' },
    { value: 'und', label: 'Other' },
    { value: 'ur', label: 'Urdu' },
    { value: 'ug', label: 'Uyghur' },
    { value: 'uz', label: 'Uzbek' },
    { value: 've', label: 'Venda' },
    { value: 'vi', label: 'Vietnamese' },
    { value: 'vo', label: 'Volapük' },
    { value: 'wa', label: 'Walloon' },
    { value: 'cy', label: 'Welsh' },
    { value: 'fy', label: 'Western Frisian' },
    { value: 'wo', label: 'Wolof' },
    { value: 'xh', label: 'Xhosa' },
    { value: 'yi', label: 'Yiddish' },
    { value: 'yo', label: 'Yoruba' },
    { value: 'za', label: 'Zhuang' }
];
